import { useState, Fragment } from 'react';
import { TextField, Autocomplete, Paper, IconButton, Divider, createFilterOptions } from '@mui/material';
import styled from '@emotion/styled';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import Dialog from './Dialog';

// hooks
import useInputDebounce from '../../hooks/useInputDebounce';

const CustomAutocomplete = styled(Autocomplete)`
 
`;

const filter = createFilterOptions();

/**
 * AutoCompletSolo - A custom autocomplete component with free solo input
 * 
 * sample usage: const options = useInputDebounce({ url: 'inventory_items', state: true });
 * @optional = displayLabel = (option) => `${option.name} - ${option.title}`
 * <AutoCompleteSolo label="Stylist" fieldName="stylist_id" newItemTitle="Stylist" {...options} />
 * 
 * @required setValue {Function} - State setter for input value
 * @required value {string} - Current input value
 * @required fieldName {string} - Option object property to use for values
 * 
 * @optional handleInputChange {Function} - Callback on input change
 * @optional loading {boolean} - Loading state (default: true)
 * @optional options {Array} - Dropdown options (default: [{name: "hello", title: "hello"}])
 * @optional popup {ReactNode} - Custom popup icon (default: null)
 * @optional newItemTitle {string} - Text for "Create new" option (default: "Item")
 * @optional displayLabel {Function} - Custom label formatter
 * @optional ...props - Additional CustomAutocomplete props
 */

const updateArr = (setArr, arr, value, updates) => {
  // updates = ["name", "title"];
  if (!value) {
    return;
  }
  let obj = {};
  updates.forEach((update) => {
    obj[update] = value[update];
  })
  setArr(oldObj => {
    let arrField = oldObj[arr] || [];
    let findExisting = arrField.find(el => el.sku === obj.sku);
    if (findExisting) {
      return oldObj;
    } else {
      let newObj = {...oldObj, [arr]: (oldObj[arr] || []).concat(obj)};
      return newObj;
    }
  });
}

const AutoCompletSolo = ({fieldName: optionField, popup = null, newItemTitle = "Item", displayLabel, size = "small", placeholder = "Search", useForm = false, FormComponent, update, serverOptions, conditionStr, server = false, ...props}) => {

  const { updates, updateFunc, arrToUpdate } = update || {};

  const { handleInputChange, loading, options, value, setValue } = useInputDebounce({ url: 'inventory_items', state: true, select: updates, serverOptions, conditionStr });

  const [openDialog, setOpenDialog] = useState(false)

  const handleChangeInput = (e, val) => {
    setValue(val);
    if (handleInputChange) {
      handleInputChange(val, e);
    }
  }

  const handleChange = (e, newValue) => {
    if (typeof newValue === 'string') {
      setValue(newValue);
    } else if (!newValue) {
      console.log("heheheehh")
      setValue('');
    } else {
      console.log(newValue, "newValue");
      setValue(newValue[optionField] || '');
    }
  };

  // console.log(value, "value");

  return (
    <Fragment>
    <Paper
      variant='outlined'
      sx={{pl: '10px', display: "flex", alignItems: 'center', flexGrow: 1}}
    >
      <CustomAutocomplete
        name="name"
        loading={loading}
        popupIcon={popup}
        options={options}
        size={size}
        onInputChange={handleChangeInput} 
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option
          }
          return option[optionField] || option.inputValue || ""
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          let label;
          if (option.inputValue) {
            label = option.title;
          } else {
            if (displayLabel) {
              label = displayLabel(option);
            } else {
              label = option[optionField];
            }
          }
          return (
            <li key={key} {...optionProps}>
              {label}
            </li>
          );
        }}
        isOptionEqualToValue={(option, value) => {
          return option.inputValue === value.inputValue || option[optionField] === value[optionField];
        }}
        onChange={(e, newValue) => {
          if (newValue && newValue.inputValue) {
            if (useForm) {
              setOpenDialog(true)
              setTimeout(() => {
                handleChange(e, "");
              }, 5);
            } else {
              handleChange(e, newValue.inputValue);
            }
          } else {
            handleChange(e, newValue);
            if (updateFunc) {
              updateArr(updateFunc, arrToUpdate, newValue, updates);
            }
          }
        }}
        inputValue={value}
        defaultValue={''}
        fullWidth
        freeSolo
        clearOnBlur
        selectOnFocus
        filterOptions={(options, params) => {
          let filtered = server ? [...options] : filter(options, params);
          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              title: `Create New ${newItemTitle}: "${params.inputValue}"`,
            });
          }
          return filtered;
        }}
        {...props}
        renderInput={(params) => {
          return (<TextField {...params} name={props.name} placeholder={placeholder} variant="outlined" sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: 'none', // Removes the border
              },
            },
          }} />)}
        }
      />
    <Divider orientation="vertical" sx={{ p: "2px 4px", height: "3rem"}}  />
      <IconButton type="button">
        <SearchRoundedIcon />
      </IconButton>
    </Paper>
    <Dialog size="md" title={`Create New ${newItemTitle}`} forceOpen={openDialog} forceClose={() => setOpenDialog(false)} text="" saveText={`Save New ${newItemTitle}`} useForm={true}>
      {FormComponent}
    </Dialog>
    </Fragment>
  )
};

export default AutoCompletSolo;